<template>
  <div v-if='this.module === "matrix"' class="gap-4 flex flex-row w-svw">
    <div v-for="sexItem in renderedSex" :key="sexItem" class="overflow-x-auto" :class="$route.meta.gender ? 'w-1/2' : 'w-full'">
      <h3 v-if="gender" class="text-lg font-semibold mb-2 text-gray-700 px-1">
        {{ sexItem }}
      </h3>

      <v-card class="rounded-lg shadow-sm overflow-visible">
        <table class="min-w-full text-sm border-collapse">
          <thead class="bg-gray-100 justify-evenly">
            <tr>
              <th class="cell">{{ $t('division') }}</th>
              <th class="cell">{{ $t('weekly') }}</th>
              <th class="cell">{{ $t('daily') }}</th>
              <th class="cell">+10%</th>
              <th class="cell">{{ $t('gain') }}</th>
              <th class="cell">CV</th>
              <th class="cell">{{ $t('uniformity') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(bd, idx) in getFilteredBatches(sexItem)" :key="idx"
              class="border-t hover:bg-gray-50 transition text-center cursor-pointer" :class="getRowClass(bd)"
              @click="selectBatchDivision(bd)">
              <td class="cell font-medium whitespace-nowrap relative">
                <span v-if="isSelected(bd.id) && !$route.meta.list"
                  class="mx-2 absolute left-0.5 top-1/2 -translate-y-1/2 w-2.5 h-2.5 bg-teal-500 rounded-full"></span>
                {{ bd.type }} {{ bd.identification }}
              </td>
              <td class="cell">{{ Math.round(bd.weekWeight) || '--' }}</td>
              <td class="cell">{{ Math.round(bd.weight) || '--' }}</td>
              <td class="cell">{{ Math.ceil(bd.weekWeight * 1.1) || '--' }}</td>
              <td class="cell">{{ Math.round(bd.weekGain) || '--' }}</td>
              <td class="cell">{{ Math.round(bd.conversionFactor) || '--' }}</td>
              <td class="cell">{{ Math.round(bd.uniformity) || '--' }}</td>
            </tr>
          </tbody>
        </table>
      </v-card>
    </div>
  </div>
  <div v-else>
    <div  class="overflow-x-auto w-full">
      <v-card class="rounded-lg shadow-sm overflow-visible">
        <table class="min-w-full text-sm border-collapse">
          <thead class="bg-gray-100 justify-evenly">
            <tr>
              <th class="cell">{{ $t('division') }}</th>
              <th class="cell">{{ $t('ambient-temperature') }}</th>
              <th class="cell">{{ $t('humidity') }}</th>
              <th class="cell">{{ $t('CO2') }}</th>
              <th class="cell">{{ $t('enthalpy') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(bd, idx) in this.batchesDivision" :key="idx"
              class="border-t hover:bg-gray-50 transition text-center cursor-pointer" :class="getEnthalpyCellClass(bd)"
              @click="selectBatchDivision(bd)">
              <td class="cell font-medium whitespace-nowrap relative">
                <span v-if="isSelected(bd.id) && !$route.meta.list"
                  class="mx-2 absolute left-0.5 top-1/2 -translate-y-1/2 w-2.5 h-2.5 bg-teal-500 rounded-full"></span>
                {{ bd.type }} {{ bd.identification }}
              </td>
              <td class="cell">
                <span class="relative inline-block group z-10">
                  {{ bd.s0?.[0]?.environmentTemperature ? `${bd.s0?.[0]?.environmentTemperature.toFixed(1)}°C` : '--' }}
                  <span class="absolute z-50 px-2 py-1 text-xs text-white bg-gray-800 rounded shadow whitespace-nowrap -translate-y-1/2 left-full ml-2 top-1/2 opacity-0 group-hover:opacity-100 transition">
                    {{ lastReadTooltip(bd.s0?.[0]?.timestamp) }}
                  </span>
                </span>
              </td>
              <td class="cell">
                <span class="relative inline-block group z-10">
                  {{ bd.s0?.[0]?.humidity != null ? Math.round(bd.s0?.[0]?.humidity) + '%' : '--' }}
                  <span class="absolute z-50 px-2 py-1 text-xs text-white bg-gray-800 rounded shadow whitespace-nowrap -translate-y-1/2 left-full ml-2 top-1/2 opacity-0 group-hover:opacity-100 transition">
                    {{ lastReadTooltip(bd.s0?.[0]?.timestamp) }}
                  </span>
                </span>
              </td>
              <td class="cell">
                <span class="relative inline-block group z-10">
                  {{ bd.d0?.[0]?.co2 ? Math.round(bd.d0?.[0]?.co2) + 'ppm' : '--' }}
                  <span class="absolute z-50 px-2 py-1 text-xs text-white bg-gray-800 rounded shadow whitespace-nowrap -translate-y-1/2 left-full ml-2 top-1/2 opacity-0 group-hover:opacity-100 transition">
                    {{ lastReadTooltip(bd.d0?.[0]?.timestamp) }}
                  </span>
                </span>
              </td>
              <td class="cell">{{ bd.s0?.[0]?.enthalpy.value ? bd.s0?.[0]?.enthalpy.value : '--'}}</td>
            </tr>
          </tbody>
        </table>
      </v-card>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import { format, parseISO } from 'date-fns';

export default {
  name: 'BatchDivisionCard',
  props: {
    batchesDivision: {
      type: Array,
      required: true
    },
    gender: Boolean,
    module: String
  },
  data() {
    return {
      sex: ['Macho', 'Fêmea']
    };
  },
  computed: {
    ...mapGetters('user', ['getIsGuest']),
    ...mapGetters('environment', ['getSelectedBatchDivisions']),

    renderedSex() {
      return this.gender ? this.sex : [null];
    }
  },
  methods: {
    ...mapMutations('environment', ['SET_SELECTED_BATCH_DIVISION', 'TOGGLE_SELECTED_BATCH_DIVISION']),

    getFilteredBatches(sex) {
      if (!this.gender) return this.batchesDivision;
      return this.batchesDivision
      // .filter(b => b.sex === sex);
    },
    getRowClass(batchDivision) {
      if (batchDivision.weekGain > 0) return 'bg-lime-100';
      if (batchDivision.weekGain < 0) return 'bg-red-100';
      return 'bg-gray-100';
    },
    selectBatchDivision(batchDivision) {
      this.TOGGLE_SELECTED_BATCH_DIVISION(batchDivision)
    },
    isSelected(id) {
      return Array.isArray(this.getSelectedBatchDivisions)
        ? this.getSelectedBatchDivisions.some(b => b.id === id)
        : false;
    },
    lastReadTooltip(timestamp) {
      if (!timestamp) {
        return `${this.$t('last_reading')}: --`;
      }
      const date = timestamp instanceof Date ? timestamp : parseISO(timestamp);
      const formatted = format(date, 'dd/MM/yyyy HH:mm:ss');
      return `${this.$t('last_reading')}: ${formatted}`;
    },
    getEnthalpyCellClass(bd) {
      const status = bd?.s0?.[0]?.enthalpy?.status;
        if (!status) return 'bg-gray-100';

        switch (status) {
          case 'comfortable':
            return 'bg-lime-100';
          case 'intermediary':
            return 'bg-yellow-100';
          default:
            return 'bg-red-100';
        }
      }
      }
};
</script>

<style lang="postcss">
table {
  width: 100%;
}
th {
  font-weight: 600;
}
.cell {
  @apply py-2 px-3;
}
</style>
